export default __webpack_public_path__ + "static/media/CEDIA-Nino-tortuga.7c19f05a.jpeg";